export default "__VITE_ASSET__BKveYiTa__"